import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { getAction } from "@/api/manage";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import { mixinDevice } from "@/utils/mixin.js";
import "@/assets/less/animation.css";
export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag: JDictSelectTag
  },
  data: function data() {
    return {
      dataSource: [],
      pagination: {
        onChange: this.pageChange,
        current: 1,
        pageSize: this._isMobile() ? 8 : 12,
        showTotal: function showTotal(total, range) {
          return range[0] + "-" + range[1] + " 共" + total + "条";
        },
        total: 0
      },
      loading: true,
      productType: "",
      tenantConfig: {},
      queryParam: {
        column: 'orderNum,createTime',
        order: 'desc',
        courseType: null,
        pageSize: 12,
        cmsStatus: 1,
        eventId: ''
      }
    };
  },
  created: function created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (this.$route.query.type) {
      this.queryParam.courseType = this.$route.query.type;
    }
    this.getList();
  },
  mounted: function mounted() {},
  methods: {
    pageChange: function pageChange(page, pageSize) {
      this.dataSource = [];
      this.pagination.current = page;
      this.pagination.pageSize = pageSize;
      this.queryParam.pageNo = this.pagination.current;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      this.loading = true;
      this.dataSource = [];
      getAction("/teaching/teachingCourse/showCourse", this.queryParam).then(function (res) {
        console.log(res);
        if (res.success) {
          _this.pagination.total = res.result.total;
          _this.dataSource = res.result.records;
        }
        _this.loading = false;
      });
    },
    toDetail: function toDetail(item) {
      var route = this.$router.resolve({
        path: "/course/detail",
        query: {
          id: item.id
        }
      });
      window.open(route.href, "_blank");
    }
  }
};